import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// 등록 학생이 정원을 넘었을 때 첫 화면에 알리는 안내.
//
// **넘긴 학생은 화면에서 사라진다.** 정원 밖으로 밀린 학생은 목록에도 과제 배정에도
// 안 나온다(`user/views.py` 가 로그인 때 is_hidden 을 매긴다). 알려 주지 않으면
// 원장은 아이가 지워진 줄 안다. 실제로 도안영어는 정원 15명에 44명이 등록돼 있어
// 29명이 조용히 빠져 있었다(2026-09-02).
//
// 서버가 숨긴 학생 수(`hidden_student_count`)를 계정 정보에 담아 준다. 그 값이
// 0 보다 크면 뜬다. '오늘 하루 보지 않기' 는 브라우저에 기억한다.
const SEEN_KEY = "capacity_over_popup_hidden_until";

// 초과 인원을 실제로 지우기로 한 날. 문구에만 쓴다(지우는 일은 아직 없다).
const DELETE_FROM_LABEL = "9월 5일";

const CapacityOverPopup = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const today = new Date().toISOString().slice(0, 10);
  const isHiddenToday = (() => {
    try {
      return window.localStorage.getItem(SEEN_KEY) === today;
    } catch (error) {
      return false;
    }
  })();

  const [isOpen, setIsOpen] = useState(!isHiddenToday);

  const overCount = user.hidden_student_count || 0;
  const capacity = user.max_student_capacity || 0;
  // **요금제가 없는 계정에는 띄우지 않는다.** 미결제 계정은 정원이 0 이라 학생이
  // 전원 숨겨져 있는데, 그것은 인원 초과가 아니라 미계약이다. 128명이 등록된
  // 무료 계정에 "정원보다 128명 많습니다" 가 뜨면 안 된다.
  if (!isOpen || overCount <= 0 || capacity <= 0) return null;
  const totalCount = (user.student_count || 0) + overCount;

  const close = (isToday) => {
    if (isToday) {
      try {
        window.localStorage.setItem(SEEN_KEY, today);
      } catch (error) {
        // 사파리 비공개 모드에서는 저장이 막힌다. 닫히기만 하면 된다.
      }
    }
    setIsOpen(false);
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(14,20,27,.55)",
        zIndex: 900,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "18px",
      }}
    >
      <div
        style={{
          background: "#fff",
          maxWidth: "380px",
          width: "100%",
          overflow: "hidden",
          boxShadow: "0 30px 70px -30px rgba(10,30,35,.6)",
        }}
      >
        <div
          style={{
            background: "#0E141B",
            color: "#fff",
            padding: "20px 22px 18px",
            position: "relative",
          }}
        >
          <button
            type="button"
            aria-label="닫기"
            onClick={() => close(false)}
            style={{
              position: "absolute",
              top: "12px",
              right: "12px",
              background: "none",
              border: "none",
              color: "#6d7d7b",
              fontSize: "18px",
              lineHeight: 1,
              cursor: "pointer",
              padding: "4px 6px",
            }}
          >
            ×
          </button>
          <div
            style={{
              fontSize: "11px",
              fontWeight: 800,
              letterSpacing: ".1em",
              color: "#E0863C",
              marginBottom: "8px",
            }}
          >
            등록 인원 초과
          </div>
          <div style={{ fontSize: "20px", fontWeight: 800, lineHeight: 1.4 }}>
            정원보다 {overCount}명
            <br />
            많이 등록되어 있습니다
          </div>
        </div>
        <div style={{ padding: "18px 22px 22px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#F4F8F7",
              padding: "12px 14px",
              fontSize: "14px",
              fontWeight: 700,
              color: "#3A434E",
            }}
          >
            <span>등록 {totalCount}명</span>
            <span style={{ color: "#8a949c" }}>정원 {capacity}명</span>
          </div>
          <div
            style={{
              fontSize: "14px",
              color: "#5b666f",
              lineHeight: 1.7,
              marginTop: "14px",
            }}
          >
            정원을 넘은 <b>{overCount}명</b>은 지금 학생 목록과 과제 배정에서 빠져
            있습니다. <b>{DELETE_FROM_LABEL}부터 초과 인원은 자동으로 삭제됩니다.</b>{" "}
            정원을 늘리시거나 등록 학생을 정리해 주세요.
          </div>
          <button
            type="button"
            onClick={() => {
              close(false);
              navigate("/academy/students");
            }}
            style={{
              display: "block",
              width: "100%",
              border: "none",
              cursor: "pointer",
              marginTop: "16px",
              background: "#00A396",
              color: "#fff",
              fontWeight: 800,
              fontSize: "15px",
              padding: "13px 0",
              fontFamily: "inherit",
            }}
          >
            재원생 관리로 가기
          </button>
          <button
            type="button"
            onClick={() => close(true)}
            style={{
              display: "block",
              width: "100%",
              marginTop: "10px",
              background: "none",
              border: "none",
              color: "#8a949c",
              fontSize: "12px",
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            오늘 하루 보지 않기
          </button>
        </div>
      </div>
    </div>
  );
};

export default CapacityOverPopup;
